import React, { Component } from "react";
import BlogstContent from "./BlogsContent";
import { Form, FormControl } from "react-bootstrap";
import QnASideBarRight from "../questionanswer/QnASideBarRight";

class Blogs extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row flex-xl-nowrap">
          <div className="col-12 col-md-3 col-xl-2 bd-sidebar mb-2 border-right border-bottom">
              {/* Toggle visible only on small screens */}
              <button
                className="btn btn-outline-secondary w-100 d-md-none mb-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#rightSidebar"
                aria-expanded="false"
                aria-controls="rightSidebar"
              >
                Sidebar • Search & Links
              </button>

              {/* Collapsible container: collapsed on < md, always shown on md+ */}
              <div id="rightSidebar" className="collapse d-md-block">
                <Form className="form-center p-2">
                  <FormControl type="text" placeholder="Search" />
                </Form>

                <ul><a href="/consul">what is consul ?</a></ul>
                <ul><a href="/cdn">what is a cdn ?</a></ul>
                <ul><a href="/git">Lets Understand GIT.</a></ul>
                <ul><a href="/lambdaAndStepFunction">Why Lambda + Step Functions.</a></ul>
                <ul><a href="/projects">sample Projects for you</a></ul>
                <ul><a href="/blind75">Must know 75 Big Tech coding interview questions</a></ul>
              </div>
            </div>
          <main
            className="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
            role="main"
          >
            <BlogstContent />
          </main>
          <div className="col-6 col-md-2 clo-xl-2 mb-2 border-left">
            <QnASideBarRight />
          </div>
        </div>
      </div>
    );
  }
}

export default Blogs;
